export default class ClaimClient {
  constructor({ url, _get, _post }) {
    this.url = url
    this.get = _get
    this.post = _post
  }

  help() {
    console.log('getNonce(address)')
    console.log('isTokenClaimed(partnerSlug, tokenId)')
    console.log('availableClaims(partnerSlug, ethAddress)')
    console.log('claimTokens(partnerSlug, claimInfo)')
  }

  new() {
    return {
      claimed_tokens: [],
      order: {
        order_id: null,
        email: '',
        eth_address: '',
        signed_message: '',
        token_ids: []
      }
    }
  }

  async claimPayment(partner_slug, paymentInfo) {
    const fallback = this.new()
    const url = `${this.url}/api/v1/partners/${partner_slug}/payment`
    const { payment_intent } = await this.post(url, null, paymentInfo, fallback)

    return payment_intent
  }

  async claimInfo(partnerSlug) {
    const fallback = {}
    const url = `${this.url}/api/v1/partners/${partnerSlug}/claims_info`
    return await this.get(url, null, fallback)
  }

  async isTokenClaimed(partnerSlug, tokenId) {
    const fallback = { claim_status: false }
    const url = `${this.url}/api/v1/partners/${partnerSlug}/claims/${tokenId}/available`
    const { claim_status } = await this.get(url, null, fallback)

    return claim_status
  }

  async availableClaims(partnerSlug, ethAddress) {
    const fallback = []
    const url = `${this.url}/api/v1/partners/${partnerSlug}/claims/${ethAddress}`
    return await this.get(url, null, fallback)
  }

  async claimTokens(partnerSlug, claimInfo) {
    const fallback = this.new()
    const url = `${this.url}/api/v1/partners/${partnerSlug}/claims`
    return await this.post(url, null, claimInfo, fallback)
  }

}
